<template>
  <!-- 分享标签 -->
  <div
    id="signCorner"
    class="share-btn-area"
    :style="tagPositionStyle"
    @click="openGuide()"
  >
    <div class="share-img">
      <img :src="formCustom.activityConfig.shareButtonStyleImgUrl" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    formCustom: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    // 分享标签位置，共四种值：'left-top' | 'right-top' | 'left-down' | 'right-down'
    // 趣味表单-分享按钮位置，1左上2左下3右上4右下
    position() {
      let res = "right-top";
      if (
        this.formCustom.activityConfig &&
        this.formCustom.activityConfig.shareButtonPosition
      ) {
        switch (this.formCustom.activityConfig.shareButtonPosition) {
          case "1":
            res = "left-top";
            break;
          case "2":
            res = "left-down";
            break;
          case "3":
            res = "right-top";
            break;
          case "4":
            res = "right-down";
            break;
          default:
            res = "right-top";
        }
      }
      return res;
    },
    tagPositionStyle() {
      let commonStyle = {};
      if (this.position === "right-down") {
        commonStyle = Object.assign(commonStyle, {
          top: `93.5vh`,
          right: 0,
          "border-radius": "18px 0 0 18px",
        });
      } else if (this.position === "right-top") {
        commonStyle = Object.assign(commonStyle, {
          top: `40px`,
          right: 0,
          "border-radius": "18px 0 0 18px",
        });
      } else if (this.position === "left-top") {
        commonStyle = Object.assign(commonStyle, {
          top: `40px`,
          left: 0,
          "border-radius": "0 18px 18px 0",
        });
      } else if (this.position === "left-down") {
        commonStyle = Object.assign(commonStyle, {
          top: `93.5vh`,
          left: 0,
          "border-radius": "0 18px 18px 0",
        });
      } else {
        // 未匹配成功，则默认右下
        commonStyle = Object.assign(commonStyle, {
          top: `calc(100vh - 198px)`,
          right: 0,
          "border-radius": "18px 0 0 18px",
        });
      }
      return commonStyle;
    },
  },
  methods: {
    openGuide() {
      sessionStorage.setItem("activityConfig", JSON.stringify(this.formCustom));
      this.$emit("getPoster", true);
    },
  },
};
</script>
<style scoped lang="scss">
.share-btn-area {
  background: #fff;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: fixed;
  z-index: 10;
  max-width: 130px;
  line-height: 15px;
  box-sizing: border-box;
  font-size: 2.6666vw;
  .share-img {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 63px;
      height: 27px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/interest-form/components/share-set.vue